/* eslint-disable no-nested-ternary */
import { SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { memo } from 'react';

import { INewOnPageResponseArray } from '../../utils/types/admin-types';
import MediaCard from '../MediaCard';
import Slider from '../UI/Slider';
import classes from './media-block.module.scss';

interface IMediaBlockProps {
  title: string;
  news: INewOnPageResponseArray[];
}

function MediaBlock({ title, news }: IMediaBlockProps) {
  return (
    <div className={classes.mediaContainer}>
      <Slider title={title}>
        <SplideTrack>
          {Array.isArray(news)
            ? news.map((card) => (
              <SplideSlide key={card.id}>
                <MediaCard
                  key={card.id}
                  title={card.title}
                  description={card.description}
                  chipText={card.tag}
                  color="#FFF"
                  image={card.picture}
                  link={card.link}
                />
              </SplideSlide>
            ))
            : null}
        </SplideTrack>
      </Slider>
    </div>
  );
}

export default memo(MediaBlock);
